/**
 * Poll intervals for clients that hit the Cloudflare Worker.
 * Every value is at least 10 seconds. The dashboard mounts all of
 * these at once — the steady-state rate is the request volume.
 */

/** Adapter health chip in the top bar. */
export const HEALTH_POLL_MS = 60_000;

/** CCTV modal. Snapshot refresh was 5s; both loops sit on the 10s floor. */
export const CCTV_CV_POLL_MS = 10_000;
export const CCTV_SNAPSHOT_POLL_MS = 10_000;

export const FEED_POLL_MS = {
  cityReports: 5 * 60_000,
  itic: 3 * 60_000,
  news: 3 * 60_000,
  weather: 30 * 60_000,
  airQuality: 15 * 60_000,
  air4thai: 30 * 60_000,
  cctv: 10 * 60_000,
  dwrCctv: 10 * 60_000,
  aqiTrend: 15 * 60_000,
  trends: 15 * 60_000,
  executive: 15 * 60_000,
  markets: 10 * 60_000,
  precip: 5 * 60_000,
  ais: 60_000,
  datago: 30 * 60_000,
  facebook: 10 * 60_000,
  marine: 30 * 60_000,
  tides: 10 * 60_000,
  reservoirs: 60 * 60_000,
  provincialKpis: 6 * 60 * 60_000,
  gistdaPoi: 60 * 60_000,
  gistdaSolar: 6 * 60 * 60_000,
  gistdaLandUse: 60 * 60_000,
  nasaEarth: 6 * 60 * 60_000,
} as const;

/** Steady-state requests per minute for a set of poll intervals. */
export function requestsPerMinute(intervalsMs: readonly number[]): number {
  return intervalsMs.reduce((sum, ms) => sum + 60_000 / ms, 0);
}

/** Feeds plus the health poll — one visible dashboard tab. */
export function dashboardPollIntervals(): number[] {
  return [...Object.values(FEED_POLL_MS), HEALTH_POLL_MS];
}
